module.exports = __webpack_public_path__ + "img/menu_gzbt.5cacb83f.png";